import React from 'react';
import { Menu } from 'antd';
import {
    UserOutlined,
    ShoppingOutlined,
    ToolOutlined,
    FileTextOutlined,
    LogoutOutlined,
} from '@ant-design/icons';
import { PROFILE_SECTIONS } from '../../../features/profile';

const iconMap = {
    [PROFILE_SECTIONS.PERSONAL_DATA]: <UserOutlined />,
    [PROFILE_SECTIONS.ORDERS]: <ShoppingOutlined />,
    [PROFILE_SECTIONS.SERVICES]: <ToolOutlined />,
    [PROFILE_SECTIONS.DOCUMENTS]: <FileTextOutlined />,
};

const ProfileSidebar = ({ activeSection, onSectionChange, onLogout }) => {
    const menuItems = [
        { key: PROFILE_SECTIONS.PERSONAL_DATA, icon: iconMap[PROFILE_SECTIONS.PERSONAL_DATA], label: 'Личные данные' },
        { key: PROFILE_SECTIONS.ORDERS, icon: iconMap[PROFILE_SECTIONS.ORDERS], label: 'Мои заказы' },
        { key: PROFILE_SECTIONS.SERVICES, icon: iconMap[PROFILE_SECTIONS.SERVICES], label: 'Мои услуги' },
        { key: PROFILE_SECTIONS.DOCUMENTS, icon: iconMap[PROFILE_SECTIONS.DOCUMENTS], label: 'Документы' },
        { type: 'divider' },
        { key: 'logout', icon: <LogoutOutlined />, label: 'Выйти', danger: true },
    ];

    const handleClick = ({ key }) => {
        if (key === 'logout') {
            onLogout();
        } else {
            onSectionChange(key);
        }
    };

    return (
        <aside className="profile-sidebar">
            <div className="profile-sidebar-menu">
                <Menu
                    mode="inline"
                    selectedKeys={[activeSection]}
                    onClick={handleClick}
                    items={menuItems}
                    className="profile-ant-menu"
                />
            </div>
        </aside>
    );
};

export default ProfileSidebar;
